import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import classnames from 'classnames'
import Button from '@material-ui/core/Button'

import { withStyles } from '@material-ui/core/styles'
import styles from './styles'
import corner from '../../img/icons/corner.svg'
import '../../styles/flipper.css'

const Boxes = withStyles(styles)(props => {
  const {
    add,
    minus,
    selected,
    classes,
    data,
  } = props

  let rows = []
  for (let r = 0; r < 4; r++) {
    let columns = []
    for (let c = 0; c < 4; c++) {
      let content = data.items.filter(
        x => parseInt(x.row) === r + 1 && parseInt(x.column) === c + 1
      )[0]

      let isSelected = false
      if (content) {
        isSelected =
          selected.filter(x => x === content.title.text).length > 0
            ? true
            : false
      }

      columns.push(
        <Grid
          container
          item
          xs={3}
          className={classnames(classes.flipperColumn)}
          alignItems="center"
          direction="column"
          justify="space-between"
          key={c}
        >
          {content ? (
            <div className={classnames('flip-card', classes.flipper)}>
              <img
                src={corner}
                className={classnames(
                  isSelected ? classes.cornerOn : classes.cornerOff
                )}
              />
              <div className={'flip-card-inner'}>
                <div
                  className={classnames('flip-card-front', classes.boxFront)}
                >
                  <Typography variant={'headline'} className={classes.boxTitle}>
                    {content.title.text}
                  </Typography>
                  <Typography className={classes.boxLead}>
                    {content.lead.text}
                  </Typography>
                </div>
                <div className={classnames('flip-card-back', classes.boxBack)}>
                  <Typography className={classes.boxDescription}>
                    {content.description.text}
                  </Typography>
                  {isSelected ? (
                    <Button
                      variant="raised"
                      size="small"
                      color={'secondary'}
                      className={classes.boxButton}
                      onClick={() => {
                        minus(content.title.text)
                      }}
                    >
                      Remove
                    </Button>
                  ) : (
                    <Button
                      variant="raised"
                      size="small"
                      color={'secondary'}
                      className={classes.boxButton}
                      onClick={() => {
                        add(content.title.text)
                      }}
                    >
                      Add
                    </Button>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div />
          )}
        </Grid>
      )
    }
    rows.push(
      <Grid container spacing={40} className={classes.flipperRow} key={r}>
        {columns}
      </Grid>
    )
  }
  return (
    <div className={classes.page}>
      <div className={classes.contents}>{rows}</div>
    </div>
  )
})

export default withStyles(styles)(Boxes)



// WEBPACK FOOTER //
// ./src/components/boxes/index.js